module.exports = __webpack_public_path__ + "static/scale-model-of-dash-point-state-park-in-tacoma-washington-fbcc8c918fcdff37f7602640ae3a709d.png";